import dayjs from 'dayjs';
import format from '@/plugins/baseFormat';
import { FRANCHISE_TYPE, } from '@/modules/franchises/constants';
import OperationFranchises from '@/models/OperationFranchises';

export default class Franchise extends OperationFranchises {
  constructor (initialData = {},) {
    super(initialData,);

    const {
      _id,
      marketplace_related,
      name,
      corporate_name,
      cnpj,
      inscricao_estadual,
      inscricao_municipal,
      mode,
      tax_regime,
      published,
      franchise_address,
      address,
      average_ticket,
      finance,
      responsible,
      attachments,
      cities_served,
      operation_stage,
      population_count,
      store_count,
      partners,
      relevant_informations,
      marketplace_franchise_id,
      type,
      operating_model,
      publish_status,
    } = initialData;

    this._id = _id;
    this.checked = false;
    this.name = name;
    this.cities_served = cities_served;
    this.operation_stage = operation_stage;
    this.formatted_operating_model = this.formatOperationModel(operating_model,);
    this.partners = partners;
    this.population_count = population_count;
    this.store_count = store_count;
    this.relevant_informations = relevant_informations;
    this.average_ticket = average_ticket;
    this.address = address;
    this.published = published;
    this.corporate_name = corporate_name;
    this.cnpj = cnpj;
    this.inscricao_estadual = inscricao_estadual;
    this.inscricao_municipal = inscricao_municipal;
    this.tax_regime = tax_regime;
    this.responsible = responsible;
    this.marketplace_related = marketplace_related;
    this.marketplace_franchise_id = marketplace_franchise_id;
    this.mode = mode || [];
    this.franchise_address = franchise_address || {};
    this.finance = finance || {};
    this.operating_model = operating_model;
    this.publish_status = publish_status;
    this.type = type || {};
    this.publish_status = publish_status;
    this.attachments = (attachments || []).map((attachment,) => {
      return {
        ...attachment,
        formatted_status:
          attachment.status === 'APPROVED'
            ? 'Aprovado'
            : attachment.status === 'DISAPPROVED'
              ? 'Reprovado'
              : 'Pendente',
        name: `${attachment.attachment_type.split('_',)[0]}.${
          attachment.key.split('.',)[1]
        }`,
      };
    },);
  }

  set franchise (franchise,) {
    this.dm_investment = franchise.dm_investment || false;
    this.consultant = franchise.consultant || null;
    this.products = franchise.products || [];
    this.franchise_id = franchise.franchise_id || null;
    this._id = franchise._id;
    this.name = franchise.name;
    this.address = franchise.address;
    this.cities_served = franchise.cities_served;
    this.operation_stage = franchise.operation_stage;
    this.formatted_operating_model = franchise.operating_model;
    this.partners = franchise.partners;
    this.population_count = franchise.population_count;
    this.store_count = franchise.store_count;
    this.relevant_informations = franchise.relevant_informations;
    this.published = franchise.published;
    this.average_ticket = franchise.average_ticket;
    this.address = franchise.address;
    this.corporate_name = franchise.corporate_name;
    this.cnpj = franchise.cnpj;
    this.inscricao_estadual = franchise.inscricao_estadual;
    this.inscricao_municipal = franchise.inscricao_municipal;
    this.tax_regime = franchise.tax_regime;
    this.responsible = franchise.responsible;
    this.marketplace_related = franchise.marketplace_related;
    this.marketplace_franchise_id = franchise.marketplace_franchise_id;
    this.mode = franchise.mode || [];
    this.franchise_address = franchise.franchise_address || {};
    this.finance = franchise.finance || {};
    this.operating_model = franchise.operating_model || '';
    this.publish_status = franchise.publish_status || '';
    this.type = franchise.type || {};
    this.publish_status = franchise.publish_status || '';
    this.attachments = (franchise.attachments || []).map((attachment,) => {
      return {
        ...attachment,
        formatted_status:
          attachment.status === 'APPROVED'
            ? 'Aprovado'
            : attachment.status === 'DISAPPROVED'
              ? 'Reprovado'
              : 'Pendente',
        name: `${attachment.attachment_type.split('_',)[0]}.${
          attachment.key.split('.',)[1]
        }`,
      };
    },);
  }

  get formatted_franchise_name () {
    return `${this.name}/${this.franchise_address.state}`;
  }

  get formatted_franchise_city_state () {
    return `${this.franchise_address.city}/${this.franchise_address.state}`;
  }

  get formatted_cities () {
    return (this.cities_served && this.cities_served.length) ? this.cities_served.join(', ',) : this.franchise_address.city;
  }

  get formatted_cnpj () {
    return format.cnpj(this.cnpj,);
  }

  get formatted_finance_cnpj () {
    return format.cnpj(this.finance.cnpj,) || '';
  }

  get formatted_finance_cpf () {
    return format.cpf(this.finance.cpf,) || '';
  }

  get formatted_average_ticket () {
    return format.money(parseFloat(this.average_ticket,) || 0,);
  }

  get formatted_store_count () {
    return format.integer(this.store_count || 0,);
  }

  get formatted_population_count () {
    return format.integer(this.population_count || 0,);
  }

  get formatted_phone () {
    return (this.responsible || {}).phone ? format.phone(this.responsible.phone,) : 'Telefone não informado';
  }

  get formatted_operation_stage () {
    return {
      IN_OPERATION: 'Em operação',
      IN_TRANSITION: 'Em transição',
      IMPLEMENTATION: 'Implementação',
    }[this.operation_stage];
  }

  get formatted_mode () {
    return {
      OWN_UNIT: 'Unidade própria',
      FRANCHISE: 'Franquia',
    }[this.mode];
  }

  get formatted_responsible_birth_date () {
    return dayjs(this.responsible.birth_date,).format('DD/MM/YYYY',) || 'Sem data de nascimento';
  }

  get formatted_responsible_cpf () {
    return format.cpf(this.responsible.cpf,) || 'CPF não informado';
  }

  get formatted_responsible_gender_identity () {
    const aliases = {
      MALE: 'Masculino',
      FEMALE: 'Feminino',
      OTHER: 'Outros',
    };

    return aliases[this.responsible.gender_identity] || 'Desconhecido';
  }

  get formatted_type () {
    return FRANCHISE_TYPE[this.type] || 'Desconhecido';
  }

  get formatted_partners () {
    return this.partners.map((partner,) => partner.name,).join(', ',);
  }

  set formatted_operation_model (operation_model,) {
    this.formatted_operating_model = operation_model;
  }

  formatOperationModel (operationModel,) {
    let operation_model = '';

    switch (operationModel) {
    case 'OWN_UNIT':
      operation_model = 'Unidade própria';
      break;

    case 'PROVISORY_OWN_UNIT':
      operation_model = 'Operação Própria Provisória';
      break;

    case 'B2B':
      operation_model = 'B2B';
      break;

    case 'ACCELERATED':
      operation_model = 'Franquia Acelerada';
      break;

    case 'ACCELERATED_V2':
      operation_model = 'Franquia Acelerada 2.0';
      break;

    case '70_30':
      operation_model = '70/30';
      break;
    }

    return operation_model;
  }

  get toPost () {
    const newResponsible = { ...this.responsible, };

    if (!this.responsible.birth_date) {delete newResponsible.birth_date;}

    newResponsible.phone = newResponsible.phone ?
      format.cleanPhone(newResponsible.phone,) : null;
    newResponsible.cpf = newResponsible.cpf ?
      format.cleanCpf(newResponsible.cpf,) : null;
    return {
      corporate_name: this.corporate_name,
      franchise_address: this.franchise_address,
      name: this.name,
      mode: this.mode,
      marketplace_related: this.marketplace_related,
      marketplace_franchise_id: this.marketplace_franchise_id,
      responsible: newResponsible,
      tax_regime: this.tax_regime,
      inscricao_estadual: this.inscricao_estadual,
      inscricao_municipal: this.inscricao_municipal,
      type: this.type,
      address: this.address.zipcode ? {
        ...this.address,
        zipcode: format.cleanSymbols(this.address.zipcode,),
      } : null,
      cpf: this.cpf ? format.cleanCpf(this.cpf,) : null,
      cnpj: this.cnpj ? format.cleanSymbols(this.cnpj,) : null,
      finance: this.finance.bank ? {
        ...this.finance,
        cpf: this.finance.cpf ? format.cleanCpf(this.finance.cpf,) : null,
        cnpj: this.finance.cnpj ? format.cleanSymbols(this.finance.cnpj,) : null,
        bank: {
          name: this.finance.bank.text,
          number: this.finance.bank.value,
        },
      } : null,
      attachments: this.attachments ? this.attachments.map((attachment,) => {
        // TODO: Testar apenas array com testes automatizados
        return {
          title: attachment.title,
          attachment_type: attachment.attachment_type,
          bucket: attachment.bucket,
          key: attachment.key,
          region: attachment.region,
        };
      },) : [],
    };
  }
}
